import dayjs from "dayjs";
import { AttributeFilterOption, SearchAppQuerySortDirection, SearchAppQuerySortField } from "./interfaces";
import { CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS } from "./attributeFilterConstants";
import { SortingBy } from "../client/Catalogue/components/SortingDropdown";
import { coreLibraryInitialised } from "@glamcorner/core-cf-lib/lib/common/gcsession/utils";
import { NAMED_SIZES_IN_ORDER } from "./constants";

export function centsToDollars(cents: any, decimalPlaces = 0): string {
  if (typeof cents !== "number") {
    return "NaN";
  }
  return (cents / 100).toFixed(decimalPlaces);
}

export function toIsoDate(day: Date | null) {
  if (day === null) {
    return "";
  }

  return dayjs(day).format("YYYY-MM-DD");
}

// In some tests coreLibraryInitialised() returns true
export function isGcSessionReady() {
  return coreLibraryInitialised() && GlamCornerCore.gcSession;
}

export const compareAttributeFilterOptions = (
  { value: opt1Value }: AttributeFilterOption,
  { value: opt2Value }: AttributeFilterOption
) => {
  if (opt1Value < opt2Value) {
    return -1;
  }
  if (opt1Value > opt2Value) {
    return 1;
  }
  return 0;
};

export const getKeyByValue = (obj: object, value: any) => Object.keys(obj).find((key) => obj[key] === value);

export function attributeFilterOptionByValue(value: string): AttributeFilterOption {
  const label = CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS[value] || value;

  return {
    label,
    value,
  };
}

export const retranslateAttributeOptionFilter = (label: string) => {
  return getKeyByValue(CUSTOM_ATTRIBUTE_FILTER_OPTION_LABELS, label) || label;
};

export function attributeFilterOptionByLabel(label: string): AttributeFilterOption {
  const value = retranslateAttributeOptionFilter(label);

  return {
    label,
    value,
  };
}

export const toSortingBy = (
  sortingField: SearchAppQuerySortField,
  sortingDirection: SearchAppQuerySortDirection
): SortingBy => {
  switch (sortingField) {
    case "entity_id":
      return SortingBy.Newest;
    case "position":
      return SortingBy.Featured;
    case "price":
      return sortingDirection === "asc" ? SortingBy.LowestPrice : SortingBy.HighestPrice;
    default:
      return SortingBy.Newest;
  }
};

export function notFalsy<T>(t: T | null | false | undefined): t is T {
  return Boolean(t);
  // return !!t;
}

export function sortSizesFn(a: string, b: string) {
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort
  // compareFn(a, b) return value	sort order
  // > 0	sort a after b
  // < 0	sort a before b
  // === 0	keep original order of a and b
  if (Number(a) && Number(b)) {
    return Number(a) - Number(b);
  }

  if (NAMED_SIZES_IN_ORDER.includes(a) && NAMED_SIZES_IN_ORDER.includes(b)) {
    return NAMED_SIZES_IN_ORDER.indexOf(a) - NAMED_SIZES_IN_ORDER.indexOf(b);
  }

  // Make sure One Size is always last option
  if (a === "OneSize") {
    return 1;
  }
  if (b === "OneSize") {
    return -1;
  }

  return a > b ? 1 : -1;
}
